import { Intervenants } from "../installation/interventions.model";
import { Suivi } from "../call/call.model";



export class PersonneSocietes {
    id_societe !: number;
	raison_sociale !: string;
	code_ebp !: string;
	role !: string;
}

export class SavSuivi {

    id_sav_suivi !: number;
	id_machine_suivie !: number;
	id_appelant !: number;
	nom_appelant !: string;
	date_debut !: string;
	facturable !: number;
	termine !: number;
	brouillon !: number;
	duree !: number;
	numero_facture !: string;
	commentaires_facturation !: string;
	nom_installation !: string;
	id_installation !: number;
    societe_facturee !: PersonneSocietes;
    intervenants !: Intervenants[];
    actions !: Action[];

}

export class Action {

    id_sav_action !: number;
    id_mat_action !: number;
    id_mat_unite !: number;
    id_action !: number;
    nom_action !: string;
    descriptif !: string;
    deplacement_done !: boolean;
    deplacement_to_do !: boolean;
    mat_classe !: string;
}


export class Personnes {
	personnes !: Personne[];
	groupes_enabled !: boolean
}


export class Personne {
	id_personne !: number;
	civilite !: string;
	prenom_nom !: string;
	id_civilite ?: number;
	prenom ?: string;
	nom ?: string;
}